@if (dataLoaded) {
    <mobilize-page-header [title]="'Contract ' + contract.contract_number" [reverse]="true"
                          [button]="headerButton"></mobilize-page-header>

    <div class="contract-details-wrapper">
        <div class="anchors">
            <div class="anchor" (click)="focusSection('documents')">
                <span class="icon-mobilize-attach"></span>
                <span>Documente (2)</span>
            </div>
            @if (contract.contract_type !== 'Wholesale') {
                <div class="anchor" (click)="focusSection('payment-schedule')">
                    <span class="icon-mobilize-analytics"></span>
                    <span>Scadentar</span>
                </div>
            }
            <div class="anchor" (click)="focusSection('options')">
                <span class="icon-mobilize-cart"></span>
                <span>Servicii ({{ services.length }})</span>
            </div>
            <!--            <div class="anchor" (click)="focusSection('history')">-->
            <!--                <span class="icon-mobilize-history"></span>-->
            <!--                <span>Istoric actiuni</span>-->
            <!--            </div>-->
        </div>

        <div
            class="financed-good-bar">{{ contract.contract_objects ? contract.contract_objects[0].vehicle_brand : '' }}
            {{ contract.contract_objects ? contract.contract_objects[0].vehicle_model : '' }}
            - {{ contract.contract_objects ? contract.contract_objects[0].colour : '' }}
        </div>

        <div class="mobilize-card">
            <div class="title">Date generale</div>

            <div class="details-row">
                <span>Numar contract</span>
                <span>{{ contract.contract_number }}</span>
            </div>
            <div class="details-row">
                <span>Tip contract</span>
                <span>{{ contract.contract_type }}</span>
            </div>
            <div class="details-row">
                <span>Stare</span>
                <span
                    [ngClass]="{'inactive': contract.contract_state === 'Inchis', 'active': contract.contract_state !== 'Inchis'}">
                @if (contract.contract_state === 'Inchis') {
                    <i class="offline"></i>
                } @else {
                    <i class="online"></i>
                }
                    {{ contract.contract_state === 'Inchis' ? 'inactiv' : 'activ' }}
            </span>
            </div>
            <div class="details-row">
                <span>Sold restant</span>
                <span [innerHTML]="formatAmount(contract.overdue_invoices_ron, 'RON')"></span>
            </div>
            <div class="details-row">
                <span>Nr. zile intarziere</span>
                <span>{{ contract.delay_days }}</span>
            </div>
            <div class="details-row">
                <span>Data</span>
                <span>{{ contract.contract_date | date: 'dd/MM/YYYY' }}</span>
            </div>
        </div>

        @if (contract.contract_type !== 'Wholesale') {
            <div class="mobilize-card" #paymentScheduleSection>
                <div class="title font-orange">Scadentar</div>

                @if (contract.contract_state !== 'Inchis') {
                    <mobilize-installments-slider [showInstallments]="contract.contract_state !== 'Inchis'"
                                                  [type]="'extended'"
                                                  [maxInstallments]="maxInstallments"
                                                  [payedInstallments]="contract.previous_instalments"></mobilize-installments-slider>

                    <div class="payment-details">
                        <div>Ai achitat din capital: <span
                            [innerHTML]="formatAmount(payedAmount, contract.currency_code)"></span>
                        </div>
                        @if (contract.outstanding) {
                            <div>Rest de plata capital: <span
                                [innerHTML]="formatAmount(contract.outstanding, contract.currency_code)"></span>
                            </div>
                        }
                    </div>
                }

                <div class="payment-actions">
                    @if (contract.contract_state !== 'Inchis' || contract.contract_type !== 'Operational') {
                        <button class="mobilize-btn btn-clear" (click)="earlyRepayment()">plateste anticipat</button>
                    }
                    <button class="mobilize-btn btn-clear" (click)="changeDueDate()">schimbare data emitere rata lunara
                    </button>
                </div>
            </div>
        }

        <div class="mobilize-card" #optionsSection>
            <div class="title font-orange">Servicii ({{ services.length }})</div>

            <div class="options-wrapper">
                @for (option of services; track option) {
                    <mobilize-contract-option class="option-component" [contractState]="contract.contract_state"
                                              [contract]="contract" [option]="option"></mobilize-contract-option>
                }
            </div>
        </div>

        <div class="mobilize-card documents" #documentsSection>
            <div class="title font-orange">Documente (2)</div>

            @for (document of contract.documents; track document) {
                <div class="document-row" (click)="getDocument(document.type)">
                    @if (!processing) {
                        <span class="icon-mobilize-export"></span>
                    } @else {
                        <mat-progress-spinner class="orange-spinner" diameter="16" strokeWidth="2"
                                              mode="indeterminate"></mat-progress-spinner>
                    }

                    <div class="document-row__details">
                        <span>{{ document.name }}</span>
                    </div>
                </div>
            }
        </div>

        <div class="mobilize-card">
            <div class="title">Date financiare</div>

            <div class="details-row">
                <span>Urmatoarea rata</span>
                @if (contract.next_installment) {
                    <span [innerHTML]="formatAmount(contract.next_installment, contract.currency_code)"></span>
                } @else {
                    <span>-</span>
                }
            </div>
            <div class="details-row">
                <span>Urmatoarea data scadenta</span>
                <span>{{ contract.next_due_date ? (contract.next_due_date | date: 'dd/LL/YYYY') : '-' }}</span>
            </div>
            <div class="details-row">
                <span>Dobanda anuala</span>
                <span>{{ contract.interest_percent }}%</span>
            </div>
            <div class="details-row">
                <span>Pret cu tot cu taxe</span>
                <span [innerHTML]="formatAmount(contract.purchasing_price_with_vat, contract.currency_code)"></span>
            </div>
            <div class="details-row">
                <span>Valoare avans (fara taxe)</span>
                <span [innerHTML]="formatAmount(contract.advance_amount, contract.currency_code)"></span>
            </div>
            <div class="details-row">
                <span>Avans</span>
                <span>{{ contract.advance_percent }}%</span>
            </div>

            @if (showMoreSections.financial) {
                <div [@toggleHeight]>
                    <div class="details-row">
                        <span>Valoare avans (cu taxe)</span>
                        <span [innerHTML]="formatAmount(contract.advance_amount, contract.currency_code)"></span>
                    </div>
                    @if (contract.contract_type !== 'Operational') {
                        <div class="details-row">
                            <span>Valoare reziduala</span>
                            <span [innerHTML]="formatAmount(contract.rezidual_amount, contract.currency_code)"></span>
                        </div>
                    }
                    <div class="details-row">
                        <span>Procent penalizari</span>
                        <span>{{ contract.penalty_percent }}%</span>
                    </div>
                </div>
            }

            <div class="show-more" [ngClass]="{'extended': showMoreSections.financial}" (click)="showMore('financial')">
                {{ showMoreSections.financial ? 'vezi mai putin' : 'vezi mai mult' }}
            </div>
        </div>

        @if (contract.contract_objects) {
            <div class="mobilize-card">
                <div class="title">Bun finantat</div>

                <div class="details-row">
                    <span>Descriere</span>
                    <span>{{ contract.contract_objects ? contract.contract_objects[0].vehicle_brand : '-' }}
                        {{ contract.contract_objects ? contract.contract_objects[0].vehicle_model : '-' }}</span>
                </div>
                <div class="details-row">
                    <span>Numar inmatriculare</span>
                    <span>{{ contract.contract_objects ? contract.contract_objects[0].registration_number : '-' }}</span>
                </div>
                <div class="details-row">
                    <span>Culoare</span>
                    <span>{{ contract.contract_objects ? contract.contract_objects[0].colour : '-' }}</span>
                </div>
                <div class="details-row">
                    <span>Tip combustibil</span>
                    <span>{{ contract.contract_objects ? contract.contract_objects[0].fuel : '-' }}</span>
                </div>
                <div class="details-row">
                    <span>Avans</span>
                    <span [innerHTML]="formatAmount(contract.advance_amount, contract.currency_code)"></span>
                </div>

                @if (showMoreSections.good && contract.contract_objects) {
                    <div [@toggleHeight]>
                        <div class="details-row">
                            <span>Serie de sasiu</span>
                            <span>{{ contract.contract_objects[0].chassis_number }}</span>
                        </div>
                        <div class="details-row">
                            <span>Anul fabricatiei</span>
                            <span>{{ contract.contract_objects[0].made_year }}</span>
                        </div>
                        <div class="details-row">
                            <span>Capacite cilindrica</span>
                            <span>{{ contract.contract_objects[0].cap_cil }}</span>
                        </div>
                    </div>
                }

                <div class="show-more" [ngClass]="{'extended': showMoreSections.good}" (click)="showMore('good')">
                    {{ showMoreSections.good ? 'vezi mai putin' : 'vezi mai mult' }}
                </div>
            </div>
        }
    </div>
}
